import { useContext } from 'react';
import { ContextAuth } from 'src/contexts';

// ========================================================================== //
// ================================= LOGIC ================================== //
// ========================================================================== //

/**
 * @description - The hook for the game component. This is containing all
 * necessary lifecycle methods and variables.
 */
const useAuth = () => {
  const context = useContext(ContextAuth);

  if (!context) throw new Error(
    'Game context must be use inside GameBaseProvider'
  );

  return context;
};

export default useAuth;
